module.exports = __webpack_public_path__ + "assets/img/amiya-nm.667e2801.gif";